// extracted by mini-css-extract-plugin
export default {"btn":"BackBtn_btn__Vwx+V","icon":"BackBtn_icon__Zcw1H","text":"BackBtn_text__neiMQ","invers":"BackBtn_invers__dhmjq"};